// 一般信用在庫まわりの管理API（Worker の /admin/* を直接呼ぶ。useAdmin.ts と同じ方式）
const WORKER_URL = (import.meta.env.VITE_WORKER_URL ?? "").replace(/\/$/, "")

export async function adminFetch<T>(path: string, opts?: RequestInit): Promise<T> {
  const res = await fetch(`${WORKER_URL}/admin${path}`, {
    ...opts,
    headers: { "Content-Type": "application/json", ...(opts?.headers ?? {}) },
  })
  if (!res.ok) {
    const body = await res.json().catch(() => null)
    const detail = body && typeof body.error === "string" ? ` (${body.error})` : ""
    throw new Error(`API error: ${res.status}${detail}`)
  }
  return res.json() as Promise<T>
}
